import { useEffect, useMemo, useState } from 'react';
import { searchNav } from './navSearch';

const EMPTY_SET = new Set();

function singletonSet(id) {
  return id ? new Set([id]) : EMPTY_SET;
}

/**
 * Shared single-open accordion state. Search expands matching trails without overwriting the
 * manual state that returns when the query is cleared.
 */
export default function useNavDisclosure(sections, active) {
  const [expandedSectionId, setExpandedSectionId] = useState(active.sectionId);
  const [expandedItemId, setExpandedItemId] = useState(active.childId ? active.itemId : null);
  const [query, setQuery] = useState('');

  useEffect(() => {
    if (active.sectionId) setExpandedSectionId(active.sectionId);
    if (active.childId) setExpandedItemId(active.itemId);
  }, [active.sectionId, active.itemId, active.childId]);

  const searchResult = useMemo(() => searchNav(sections, query), [query, sections]);
  const isSearching = query.trim().length > 0;
  const expandedSectionIds = isSearching
    ? searchResult.matchingSectionIds
    : singletonSet(expandedSectionId);
  const expandedItemIds = isSearching
    ? searchResult.itemIdsWithMatchingChildren
    : singletonSet(expandedItemId);

  const toggleSection = id => {
    if (isSearching) return;
    setExpandedSectionId(previous => (previous === id ? null : id));
    setExpandedItemId(null);
  };
  const toggleItem = id => {
    if (isSearching) return;
    setExpandedItemId(previous => (previous === id ? null : id));
  };

  return {
    query, setQuery, searchResult, isSearching, expandedSectionIds, expandedItemIds,
    toggleSection, toggleItem,
  };
}
